import React, { Component } from 'react'
import {
  Form,
  Divider,
  Input,
  Row,
  Col,
  Upload,
  message,
  DatePicker,
  Select,
  Checkbox
} from 'antd'
import moment from 'moment'
import { connect } from 'react-redux';
import { uploadMutipleFile, getApp, handleChangeApp } from '../../actions/app'
import { PlusOutlined, LoadingOutlined, InboxOutlined } from '@ant-design/icons';
const { Option } = Select;

const dateFormat = 'DD/MM/YYYY';
const { Dragger } = Upload;
class Basic extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loadingImage: false,
      fileList: [],
      appFileList: []
    }

  }

  componentDidMount() {

    this.setState({
      fileList: this.props.app.app_video,
      appFileList: this.props.app.app_file
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.app.app_file !== prevProps.app.app_file) {
      this.setState({
        fileList: this.props.app.app_video,
        appFileList: this.props.app.app_file
      })
    }
  }


  getBase64(img, callback) {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
  }

  beforeUpload(file) {
    // const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    // if (!isJpgOrPng) {
    //   message.error('You can only upload JPG/PNG file!')
    // }
    // const isLt4M = file.size / 1024 / 1024 < 4
    // if (!isLt4M) {
    //   message.error('Image must smaller than 4MB!')
    // }
    // return isJpgOrPng && isLt4M
    return true
  }

  handleUploadImage(file) {
    uploadMutipleFile(file, `${file.uid}/app/img`).then(result => {
      const { url, isSuccess } = result

      if (isSuccess) {
        const { handleChangeApp, app } = this.props
        app['app_img'] = url
        handleChangeApp(app)
      }
    })
  }


  handleChangeImage = (info) => {
    if (info.file.status === 'uploading') {
      this.setState({ loadingImage: true })
      return
    }
    if (info.file.status === 'done' || info.file.status === 'error') {
      // Get this url from response in real world.
      this.handleUploadImage(info.file.originFileObj)
      this.getBase64(info.file.originFileObj, _ => this.setState({
        loadingImage: false,
      }
      ))
    }
  };


  handleOnChangeDate(name, value) {
    const { handleChangeApp, app } = this.props
    app[name] = value
    handleChangeApp(app)
  }


  handleOnChange(e) {
    const { value, name } = e.target
    const { handleChangeApp, app } = this.props
    app[name] = value
    handleChangeApp(app)
  }

  handleOnChangeNumber(e) {
    const { value, name } = e.target
    if (+value || value === '') {
      const { handleChangeApp, app } = this.props
      app[name] = value
      handleChangeApp(app)
    }
  }

  handleOnRemove(info) {
    const { uid } = info;

    const { handleChangeApp, app } = this.props
    const newData = app.app_video.filter(item => item.uid !== uid)

    app.app_video = newData
    this.setState({
      fileList: newData
    })
    handleChangeApp(app)

  }
  handleOnRemoveAppFile(info) {
    const { uid } = info;

    const { handleChangeApp, app } = this.props
    const newData = app.app_file.filter(item => item.uid !== uid)

    app.app_file = newData
    this.setState({
      appFileList: newData
    })
    handleChangeApp(app)

  }

  onChangeFile(info) {
    const { status, type, name, originFileObj, uid } = info.file;
    this.setState({
      fileList: info.fileList
    })

    if (status === 'done' || status === 'error') {
      info.fileList[info.fileList.length - 1].status = "uploading"
      this.setState({
        fileList: info.fileList
      })
      uploadMutipleFile(originFileObj, `app/`, type).then(result => {
        const { url, isSuccess } = result

        if (isSuccess) {
          const { handleChangeApp, app } = this.props
          app.app_video.push(
            {
              uid,
              name,
              status: 'done',
              url,
              type
            }
          )
          this.setState({
            fileList: app.app_video
          })
          handleChangeApp(app)
          message.success(`${info.file.name} file uploaded successfully.`);
        } else {
          message.error(`${info.file.name} file uploaded fail.`);
        }
      })

    }
  }

  onChangeFileApp(info) {
    const { status, type, name, originFileObj, uid } = info.file;
    this.setState({
      appFileList: info.fileList
    })

    if (status === 'done' || status === 'error') {
      info.fileList[info.fileList.length - 1].status = "uploading"
      this.setState({
        appFileList: info.fileList
      })
      uploadMutipleFile(originFileObj, `app/`, type).then(result => {
        const { url, isSuccess } = result

        if (isSuccess) {
          const { handleChangeApp, app } = this.props
          app.app_file = [{
            uid,
            name,
            status: 'done',
            url,
            type
          }]
          this.setState({
            appFileList: app.app_file
          })
          handleChangeApp(app)
          message.success(`${info.file.name} file uploaded successfully.`);
        } else {
          message.error(`${info.file.name} file uploaded fail.`);
        }
      })

    }
  }
  render() {
    const { TextArea, } = Input
    const { loadingImage, fileList, appFileList } = this.state

    const uploadButton = (
      <div>
        {
          loadingImage ? (<LoadingOutlined></LoadingOutlined>) : (<PlusOutlined></PlusOutlined>)
        }

        <div className="ant-upload-text">Drop an image here, or select a file.</div>
      </div>
    )

    const {
      app_img,
      title,
      subtitle,
      amount,
      start_date,
      description,
      location,
      is_product,
      version,
      message_tip,
      desktop,
      link_desktop,
      ios,
      link_ios,
      link_android,
      android,
      free,
      link_web,
      web
    } = this.props.app
    console.log(appFileList)
    return (
      <div className="project-flow">

        <h2 className="project-flow__title">Start with the basics</h2>
        <div className="project-flow__title project-flow__title-sub"> Make it easy for people to learn about your project.</div>
        <Divider />
        <Form layout={"vertical"} className="project-flow__form">
          <Row>
            <Col sm={24} md={10}>
              <div className="project-flow__title project-flow__des__title">App title</div>
              <div className="project-flow__title project-flow__title-sub project-flow__des__sub">
                Write a clear, brief title that helps people quickly understand the gist of your app.
              </div>
            </Col>
            <Col sm={24} md={14}>

              <Form.Item
                label="Title"
              >
                <Input
                  placeholder="Title"
                  name="title"
                  value={title}
                  onChange={(e) => this.handleOnChange(e)}
                />
              </Form.Item>

              <Form.Item
                label="Subtitle"
              >
                <TextArea
                  rows={3}
                  placeholder="Subtitle"
                  name="subtitle"
                  value={subtitle}
                  onChange={(e) => this.handleOnChange(e)}
                />
              </Form.Item>
              <Form.Item
                label="Description"
              >
                <TextArea
                  rows={5}
                  placeholder="Description"
                  name="description"
                  value={description}
                  onChange={(e) => this.handleOnChange(e)}
                />
              </Form.Item>
            </Col>
          </Row>

          <Divider />
          <Row>
            <Col sm={24} md={10}>
              <div className="project-flow__title project-flow__des__title">App Links</div>
              <div className="project-flow__title project-flow__title-sub project-flow__des__sub">
                Check the operating system what your app is based. And fill your app links.
              </div>
              <div className="project-flow__title project-flow__title-sub project-flow__des__sub">
                Give some message tip and version of your app.
              </div>
            </Col>
            <Col sm={24} md={14}>
              <Form.Item
                label="Operating system"
              >
                <br />
                <Checkbox checked={web} onChange={(e) => { this.handleOnChangeDate('web', e.target.checked) }}>Web</Checkbox>
                {desktop ? (
                  <Input
                    placeholder="Fill your web link"
                    name="link_web"
                    value={link_web}
                    onChange={(e) => this.handleOnChange(e)}
                  />
                ) : null}
                <br />
                <Checkbox checked={desktop} onChange={(e) => { this.handleOnChangeDate('desktop', e.target.checked) }}>Desktop</Checkbox>
                {desktop ? (
                  <Input
                    placeholder="Fill your desktop link"
                    name="link_desktop"
                    value={link_desktop}
                    onChange={(e) => this.handleOnChange(e)}
                  />
                ) : null}
                <br />
                <Checkbox checked={ios} onChange={(e) => { this.handleOnChangeDate('ios', e.target.checked) }}>Ios</Checkbox>
                {ios ? (
                  <Input
                    placeholder="Fill your ios link"
                    name="link_ios"
                    value={link_ios}
                    onChange={(e) => this.handleOnChange(e)}
                  />
                ) : null}
                <br />
                <Checkbox checked={android} onChange={(e) => { this.handleOnChangeDate('android', e.target.checked) }}>Android</Checkbox>
                {android ? (
                  <Input
                    placeholder="Fill your android link"
                    name="link_android"
                    value={link_android}
                    onChange={(e) => this.handleOnChange(e)}
                  />
                ) : null}

              </Form.Item>

              <Form.Item
                label="Version"
              >
                <Input
                  placeholder="Version"
                  name="version"
                  value={version}
                  onChange={(e) => this.handleOnChange(e)}
                />
              </Form.Item>
              <Form.Item
                label="Tip"
              >
                <TextArea
                  rows={3}
                  placeholder="Tip of your app"
                  name="message_tip"
                  value={message_tip}
                  onChange={(e) => this.handleOnChange(e)}
                />
              </Form.Item>
            </Col>
          </Row>

          <Divider />
          <Row>
            <Col sm={24} md={10}>
              <div className="project-flow__title project-flow__des__title">App image</div>
              <div className="project-flow__title project-flow__title-sub project-flow__des__sub">
                Add an image that clearly represents your app.
              </div>
              <div className="project-flow__title project-flow__title-sub project-flow__des__sub">
                Choose one that looks good at different sizes. It will appear in different sizes in different places: on your project page, across the Kickstarter website and mobile apps, and (when shared) on social channels.
              </div>
              <div className="project-flow__title project-flow__title-sub project-flow__des__sub">
                You may want to avoid including banners, badges, and text because they may not be legible at smaller sizes.
              </div>
              <div className="project-flow__title project-flow__title-sub project-flow__des__sub">
                Your image should be at least 1024x576 pixels. It will be cropped to a 16:9 ratio.
              </div>
              <div className="project-flow__title project-flow__title-sub project-flow__des__sub">
                For member images, the recommended dimensions are 180px by 180px, but the minimum is 160px by 160px. You can go larger, just make sure you maintain a 1:1 scale.
              </div>
            </Col>
            <Col sm={24} md={14}>

              <Form.Item
                label="App's image"
              >
                <Upload
                  name="app_img"
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={false}
                  action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                  beforeUpload={(file) => { this.beforeUpload(file) }}
                  onChange={(info) => { this.handleChangeImage(info) }}
                >
                  {app_img ? <img src={app_img} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                </Upload>
              </Form.Item>


            </Col>

          </Row>
          <Divider />
          <Row>
            <Col sm={24} md={10}>
              <div className="project-flow__title project-flow__des__title">App location</div>
              <div className="project-flow__title project-flow__title-sub project-flow__des__sub">
                Enter the location that best describes where your app is based.
              </div>
            </Col>
            <Col sm={24} md={14}>

              <Form.Item
                label="Location"
              >
                <Input
                  placeholder="Location"
                  name="location"
                  value={location}
                  onChange={(e) => this.handleOnChange(e)}
                />
              </Form.Item>
            </Col>
          </Row>

          <Divider />
          <Row>
            <Col sm={24} md={10}>
              <div className="project-flow__title project-flow__des__title">App category</div>
              <div className="project-flow__title project-flow__title-sub project-flow__des__sub">
                Choose the category that most closely aligns with your app.
              </div>
              <div className="project-flow__title project-flow__title-sub project-flow__des__sub">
                You’ll be able to change the category and subcategory even after your project is live.
              </div>
            </Col>
            <Col sm={24} md={14}>

              <Form.Item
                label="Category"
              >
                <Select defaultValue={is_product} style={{ width: "100%" }} onChange={(value) => { this.handleOnChangeDate('is_product', value) }}>
                  <Option value={true}>Productivity</Option>
                  <Option value={false}>Social Networking</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Divider />
          <Row>
            <Col sm={24} md={10}>
              <div className="project-flow__title project-flow__des__title">App video (optional)</div>
              <div className="project-flow__title project-flow__title-sub project-flow__des__sub">
                Add a video that describes your app.
              </div>
              <div className="project-flow__title project-flow__title-sub project-flow__des__sub">
                Tell people what you’re raising funds to do, how you plan to make it happen, who you are, and why you care about this project.
              </div>
              <div className="project-flow__title project-flow__title-sub project-flow__des__sub">
                After you’ve uploaded your video, use our editor to add captions and subtitles so your project is more accessible to everyone.
              </div>

            </Col>
            <Col sm={24} md={14}>

              <Form.Item
                label="App's video"
              >
                <Dragger fileList={fileList} onRemove={(file) => { this.handleOnRemove(file) }} name="file" multiple={false} action="https://www.mocky.io/v2/5cc8019d300000980a055e76" onChange={(info) => { this.onChangeFile(info) }}>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined style={{ color: '#30004F' }} />
                  </p>
                  <p className="ant-upload-text">Click or drag file to this area to upload</p>
                  <p className="ant-upload-hint">
                    Support for a single or bulk upload. Strictly prohibit from uploading company data or other
                    band files
                </p>
                </Dragger>
              </Form.Item>


            </Col>
          </Row>

          <Divider />
          <Row>
            <Col sm={24} md={10}>
              <div className="project-flow__title project-flow__des__title">Funding goal</div>
              <div className="project-flow__title project-flow__title-sub project-flow__des__sub">
                Set an achievable goal that covers what you need to complete your app.
              </div>
            </Col>
            <Col sm={24} md={14}>

              <Form.Item
                label="Goal amount per month"
              >
                <Checkbox checked={free} onChange={(e) => { this.handleOnChangeDate('free', e.target.checked) }}>Free</Checkbox>
                {!free ? (
                  <Input
                    placeholder="Goal amount"
                    name="amount"
                    prefix="$"
                    value={amount}
                    onChange={(e) => this.handleOnChangeNumber(e)}
                  />) : null
                }
              </Form.Item>


            </Col>
          </Row>
          <Divider />
          <Row>
            <Col sm={24} md={10}>
              <div className="project-flow__title project-flow__des__title">App file (optional)</div>
              <div className="project-flow__title project-flow__title-sub project-flow__des__sub">
                Add a file that can install your app.
              </div>

            </Col>
            <Col sm={24} md={14}>

              <Form.Item
                label="App's File"
              >
                <Dragger beforeUpload={(file) => { this.beforeUpload(file) }} fileList={appFileList} onRemove={(file) => { this.handleOnRemoveAppFile(file) }} name="app_file" multiple={false} action="https://www.mocky.io/v2/5cc8019d300000980a055e76" onChange={(info) => { this.onChangeFileApp(info) }}>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined style={{ color: '#30004F' }} />
                  </p>
                  <p className="ant-upload-text">Click or drag file to this area to upload. And allowed only one file.</p>

                </Dragger>
              </Form.Item>


            </Col>
          </Row>

          <Divider />
          <Row>
            <Col sm={24} md={10}>
              <div className="project-flow__title project-flow__des__title">Target launch date (optional)</div>
              <div className="project-flow__title project-flow__title-sub project-flow__des__sub">
                Enter a date when you plan to launch—you can always return to this after you’ve built out more of your Kickstarter app page.
              </div>
              <div className="project-flow__title project-flow__title-sub project-flow__des__sub">
                We won’t automatically launch your project.
                </div>
            </Col>
            <Col sm={24} md={14}>

              <Form.Item

              >
                <ul>
                  <li className="general-detail__campaign__group">

                    <DatePicker showUploadList={false} style={{ width: '100%' }} value={moment(start_date, dateFormat)} format={dateFormat} onChange={(_, dateString) => { this.handleOnChangeDate('start_date', dateString) }} />
                    <Divider />
                    <div className="">
                      <h4 className="general-detail__campaign__group--title-sub">We estimate you’ll have enough time if you:</h4>
                      <p className="cardContent__price-sub">Confirm your identity and provide payment details. </p>
                      <p className="cardContent__price-sub">Submit your app for review.</p>
                    </div>
                  </li>
                </ul>


              </Form.Item>


            </Col>
          </Row>
        </Form>

      </div>
    )
  }
}


const mapStateToProps = state => ({
  app: state.app || {},
});

function mapDispatchToProps() {
  return {
    getApp: (id) => getApp(id),
    handleChangeApp: (data) => handleChangeApp(data)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Basic);
